export default __webpack_public_path__ + "static/media/mail.a5b085aa.svg";